import { defineAsyncComponent } from "vue";
import ErrorComponent from "./error.vue";

export default defineAsyncComponent({
    loader: () => import("./component.vue"),
    delay: 0,
    timeout: 5000,
    suspensible: true,
    errorComponent: ErrorComponent,
})